import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-check',
  imports: [],
  templateUrl: './check.html',
  styleUrl: './check.scss',
})
export class Check {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
